const getDomainSuffix = (url) => {
  if (!url) return "localhost";
  const urlObj = new URL(url);
  const domainParts = urlObj.hostname.split(".");
  return `.${domainParts.slice(-2).join(".")}`;
};

exports.getDomainSuffix = getDomainSuffix;